export enum ProviderType {
    Coursera = 0,
    Udemy = 1,
    Internal = -1,
  }
  